import React, { useEffect, useState } from 'react'
import { apiBaseUrl } from '../constants'

export const TOKEN_KEY = 'viamaps-token'

export const LoginContext = React.createContext({})

export const LoginProvider = (props) => {

	const [sistemas, setSistemas] = useState([])
	const [login, setarLogin] = useState({
		token: null,
		usuario: null
	})

	function doLogin(values) {
		localStorage.setItem(TOKEN_KEY, values.token)
		setarLogin(values)
		getSistemas()
	}

	async function getSistemas() {
		const response = await fetch(`${apiBaseUrl}/action/Sistema/sistemasAtivos`)
		const json = await response.json()
		if (response.ok) {
			let sistemasAtivos = json.data.filter(sistema => sistema.clientes_internet === true)
			setSistemas(sistemasAtivos)
		}
	}

	async function checarToken() {
		const token = localStorage.getItem(TOKEN_KEY)
		if (token) {
			const response = await fetch(`${apiBaseUrl}/action/Usuario/checarToken`, {
				method: "POST",
				body: JSON.stringify({ accessToken: token }),
				headers: { "Content-type": "application/json" }
			})

			const json = await response.json()

			if (response.ok && json.user) {
				const data = { token, usuario: json.user.usuario }
				doLogin(data)
				getSistemas()
			} else {
				logout()
			}
		}
	}

	async function logout() {
		localStorage.removeItem(TOKEN_KEY)
		setarLogin({ token: null, usuario: null })
	}

	useEffect(() => {
		checarToken()
	}, []);

	return <LoginContext.Provider value={{ login, sistemas, doLogin, logout }}>{props.children}</LoginContext.Provider>

}

export const useLogin = () => React.useContext(LoginContext)
